// POST JOB SCHEDULES
export const POST_EXTJOBSCHEDULES_REQUEST = "POST_EXTJOBSCHEDULES_REQUEST";
export const POST_EXTJOBSCHEDULES_SUCCESS = "POST_EXTJOBSCHEDULES_SUCCESS";
export const POST_EXTJOBSCHEDULES_FAILURE = "POST_EXTJOBSCHEDULES_FAILURE";

// PUT JOB SCHEDULES
export const PUT_EXTJOBSCHEDULES_REQUEST = "PUT_EXTJOBSCHEDULES_REQUEST";
export const PUT_EXTJOBSCHEDULES_SUCCESS = "PUT_EXTJOBSCHEDULES_SUCCESS";
export const PUT_EXTJOBSCHEDULES_FAILURE = "PUT_EXTJOBSCHEDULES_FAILURE";

// DELETE JOB SCHEDULES
export const DELETE_EXTJOBSCHEDULES_REQUEST = "DELETE_EXTJOBSCHEDULES_REQUEST";
export const DELETE_EXTJOBSCHEDULES_SUCCESS = "DELETE_EXTJOBSCHEDULES_SUCCESS";
export const DELETE_EXTJOBSCHEDULES_FAILURE = "DELETE_EXTJOBSCHEDULES_FAILURE";